@import 'styles/variables';

.NodeDragHandle {
  width: 16px;
  height: 24px;
  display: flex;
  border-radius: 4px;
  transform: translateY(var(--offsetY, 0px));

  svg {
    color: var(--neutral-30);
  }

  &:hover {
    background: $grey-10;
    cursor: grab;
  }
  &.isDragging {
    background: $grey-20;
    cursor: grabbing;
  }
  &::after {
    // Provides a bigger hit area for the drag handle
    content: '';
    display: block;
    width: 22px;
    height: 30px;
    position: absolute;
  }
}
